/** 与 backend/utils/order/orderCurrentAccountsReceivable.js 口径一致 */

export const PREPAYMENT_AR_TITLE = '预付';
export const DELIVERY_AR_TITLE = '发货/提供服务';
export const ACCEPT_AR_TITLE = '验收';

/** 发货/验收等履约后才确立的准应收（统计与待办共用 label） */
export const TAIL_QUASI_RECEIVABLE_LABEL = '准应收';

const normalizeIsPaid = (isPaid) => {
	if (typeof isPaid === 'boolean') return isPaid;
	if (typeof isPaid === 'string') return isPaid === 'true' || isPaid === 'True' || isPaid === 'TRUE';
	return false;
};

/**
 * 单订单、指定应收 title：已开应收金额按已付/未付拆分（仅 amount>0；不含准应收）。
 * @returns {{ paid: number, pending: number }}
 */
export function sumOrderOpenedArByTitle(order, title) {
	let paid = 0;
	let pending = 0;
	const arList = order?.accountsReceivables || [];
	for (const ar of arList) {
		if (!ar || ar.title !== title) continue;
		const amount = Number(ar.accountsReceivable) || 0;
		if (!(amount > 0)) continue;
		if (normalizeIsPaid(ar.isPaid)) paid += amount;
		else pending += amount;
	}
	return { paid, pending };
}

/** 未付预付款（待确认收款；不计入 currentAccountsReceivable） */
export function getOrderPendingPrepaymentAmount(order) {
	return sumOrderOpenedArByTitle(order, PREPAYMENT_AR_TITLE).pending;
}

/** 确立应收账款（即 currentAccountsReceivable 字段语义） */
export function getOrderEstablishedAccountsReceivable(order) {
	return Number(order?.currentAccountsReceivable) || 0;
}

/** 审批/列表展示：待预付阶段展示待收预付，否则展示确立应收 */
export function getOrderReceivableMetricForDisplay(order) {
	const pendingPrepayment = getOrderPendingPrepaymentAmount(order);
	const paymentStatus = order?.paymentStatus;
	if (paymentStatus === 'waitingPayPlaceOrder' && pendingPrepayment > 0) {
		return {
			label: '待收预付',
			amount: pendingPrepayment,
			kind: 'pendingPrepayment',
		};
	}
	const established = getOrderEstablishedAccountsReceivable(order);
	return {
		label: '应收账款',
		amount: established,
		kind: 'established',
	};
}
